import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { AcercadeComponent } from 'src/app/components/shared/components/acercade/acercade.component';
import { MainLayoutService } from './main-layout.service';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
})
export class MainLayoutComponent implements OnInit {
  view: boolean = false;
  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;
  notifications = [];
  notificaciones = [];
  title: string;
  viewConfig: boolean = false;
  viewNotifications = false;
  isFRD;
  countNotifications = 0;
  units = [];
  nav = [];

  constructor(
    private router: Router,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    public mainLayoutService: MainLayoutService,
    private _snackBar: MatSnackBar
  ) {
    this.mainLayoutService.initializeComponent(this);
  }

  get name() {
    return this.mainLayoutService.name;
  }
  get roeleName() {
    return this.mainLayoutService.roeleName;
  }
  get photo() {
    return this.mainLayoutService.photo;
  }

  ngOnInit(): void {
    this.mainLayoutService.setupSocketConnection(this);
    this.mainLayoutService.getNotifications(this);
  }

  doLogout() {
    this.mainLayoutService.doLogout();
  }

  getUnits() {
    this.mainLayoutService.getUnits(this);
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  get permissions() {
    return this.mainLayoutService.permissions;
  }
  get seeSkuld() {
    return this.mainLayoutService.seeSkuld;
  }
  get anaUnit() {
    return this.mainLayoutService.anaUnit;
  }
  get seeAna() {
    return this.mainLayoutService.seeAna;
  }
  get userUnits() {
    return this.mainLayoutService.userUnits;
  }
  get sklud() {
    return this.mainLayoutService.sklud;
  }
  get seeUsers() {
    return this.mainLayoutService.seeUsers;
  }
  get seeRoles() {
    return this.mainLayoutService.seeRoles;
  }
  get immersionPermission() {
    return this.mainLayoutService.immersionPermission;
  }
  get forskerPermission() {
    return this.mainLayoutService.forskerPermission;
  }
  get seeLogSistemControl() {
    return this.mainLayoutService.seeLogSistemControl;
  }
  get seeLogCases() {
    return this.mainLayoutService.seeLogCases;
  }
  get seeMainReports() {
    return this.mainLayoutService.seeMainReports;
  }
  get seeStatusConection() {
    return this.mainLayoutService.seeStatusConection;
  }
  get seeUnits() {
    return this.mainLayoutService.seeUnits;
  }

  openAcercaDe() {
    this.dialog.open(AcercadeComponent);
  }

  clickNav(option: any) {
    this.mainLayoutService.clickNav(this, option);
  }
}
